<template>
  <ts-loading-banner :loading="waiting">
    <div class="ts-space-y-4">
      <div class="row">
        <div class="col-12 ts-space-y-1">
          <label class="required">{{ $t('bankProfile.bankName') }}</label>
          <input
            v-model="model.bank_name"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('bank_name') }"
          />
          <div class="invalid-feedback" v-if="errors.has('bank_name')">
            {{ errors.first('bank_name') }}
          </div>
        </div>
      </div>
      <div class="row">
        <detail-template
          v-model="model"
          :validation="errors"
          class="ts-w-full"
        />
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting_new"
            :disabled="waiting_new || waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t('save_add_new') }}</ts-button
          >
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t('save')
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            :waiting="waiting"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DetailTemplate from './components/detail.vue'
export default {
  name: 'bankProfileForm',
  components: {
    DetailTemplate,
  },
  data() {
    return {
      objectContain: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      banks: [],
      model: {
        bank_id: null,
        bank_name: null,
        detail: [],
      },
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('bankProfile', ['edit_data']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    },
  },
  methods: {
    photoUpload(property = 'image_qr_code', index = 0) {
    const detail = this.model.detail[index];

      if (detail && detail[property]) {
        if (detail[property] instanceof File || detail[property] instanceof Blob) {
          let formData = new FormData();
          formData.append(property, detail[property]);

          return this.$store.dispatch('bankProfile/photoUpload', formData);
        }

        return detail[property];
      }
    },
    async onSave() {
      this.errors = new Errors()
      let photo_path = await this.photoUpload()
      this.waiting = true
      this.$store
        .dispatch('bankProfile/store', Object.assign({}, this.model, {
          ...this.model,
          detail: this.model.detail.map((item, index) => {
            
              return {
                ...item,
                image_qr_code: photo_path,
              };
          
          }),
        }))
        .then((response) => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profiles' })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.$notify({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onSaveAddNew() {
      this.errors = new Errors()
      let photo_path = await this.photoUpload()
      this.waiting_new = true
      this.$store
        .dispatch('bankProfile/store', Object.assign({}, this.model, {
            ...this.model,
            detail: this.model.detail.map((item, index) => {
              
                return {
                  ...item,
                  image_qr_code: photo_path,
                };
            
            }),
        }))
        .then((response) => {
          this.waiting_new = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profiles' })
          this.clearEdit()
        })
        .catch((error) => {
          this.errors = new Errors(error.errors)
          this.$notify({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    async onUpdate() {
      this.waiting = true
      let photo_path = await this.photoUpload()
      this.$store
        .dispatch('bankProfile/update', Object.assign({}, this.model, {
          ...this.model,
          detail: this.model.detail.map((item, index) => {
            
              return {
                ...item,
                image_qr_code: photo_path,
              };
          
          }),
        }))
        .then((response) => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profiles' })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.errors = new Errors(error.errors)
          this.$notify({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.bank_id = this.edit_data.bank_id
        this.model.bank_name = this.edit_data.bank_name
        this.edit_data.bank_accounts.map((el) =>
        this.model.detail.push({
            account_id: el.account_id,
            account_name: el.account_name,
            account_number: el.account_number,
            image_qr_code: el.image_qr_code,
            remarks: el.remarks ? el.remarks : null,
          })
        )
      }
    },
    clearEdit() {
      this.model.bank_id = null
      this.model.bank_name = null
      this.model.detail = []
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
</style>